const pad = (n) => String(n).padStart(2, "0");

export const addDaysISO = (iso, days) => {
  const d = new Date(`${iso}T00:00:00`);
  d.setDate(d.getDate() + days);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const fmtISO = (iso) => (iso ? new Date(`${iso}T00:00:00`).toLocaleDateString("pt-BR") : "");

export const ENTRADA_METHODS = ["PIX", "Dinheiro", "Cartão de Crédito", "Cartão de Débito", "Cheque", "Transferência"];

// Plano de pagamento do pedido: entrada (paga no ato) + parcelas do restante. Mesma matemática do backend (order_plan).
export const buildPlan = ({ total, installments, payment_method, boleto_days, order_date, entrada_value, due_dates }) => {
  const t = Math.round((parseFloat(total) || 0) * 100);
  const n = Math.min(Math.max(parseInt(installments) || 1, 1), 60);
  const entrada = Math.round((parseFloat(entrada_value) || 0) * 100);
  const bd = payment_method === "Boleto" ? parseInt(boleto_days) || 0 : 0;
  let error = null;
  if (entrada < 0) error = "A entrada não pode ser negativa";
  else if (entrada > 0 && t > 0 && entrada >= t) error = "A entrada deve ser menor que o valor total do pedido — para venda à vista, não informe entrada";
  const restante = Math.max(t - entrada, 0);
  const base = Math.round(restante / n);
  const parcelas = Array.from({ length: n }, (_, i) => {
    const cents = i === n - 1 ? restante - base * (n - 1) : base;
    const custom = (due_dates || [])[i] || "";
    const auto = order_date ? addDaysISO(order_date, bd > 0 ? bd * (i + 1) : 30 * (i + (entrada > 0 ? 1 : 0))) : "";
    return { due_date: custom || auto, amount: cents / 100, custom: !!custom };
  });
  const soma = entrada + parcelas.reduce((s, p) => s + Math.round(p.amount * 100), 0);
  if (!error && t > 0 && soma !== t) error = "Entrada + parcelas não fecham com o total do pedido";
  return { total: t / 100, entrada: entrada / 100, restante: restante / 100, parcelas, error, hasCustom: parcelas.some((p) => p.custom) };
};
